import { createFileRoute } from "@tanstack/react-router"
import { EventDetailPage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Resource, Action } from "@mimber/schema"

export const Route = createFileRoute(
  "/_authenticated/_organization/events/$eventUuid/$tabKey"
)({
  component: function EventTabRoute() {
    return (
      <AuthorizationGate resource={Resource.EVENT} action={Action.READ}>
        <EventDetailPage />
      </AuthorizationGate>
    )
  },
})
